import { render, staticRenderFns } from "./MailTracking.vue?vue&type=template&id=6876629a&scoped=true&lang=pug&"
import script from "./MailTracking.vue?vue&type=script&lang=js&"
export * from "./MailTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6876629a",
  null
  
)

export default component.exports